export const PHYSICS_TUNING = Object.freeze({
  gravity: Object.freeze({ x: 0, y: -19.5, z: 0 }),
});
